/** Travels up the node tree until it finds its ancestrally assigned slot. */
const findAssignedSlot = (el) => {
    if (el.assignedSlot)
        return el.assignedSlot;
    if (el.parentElement)
        return findAssignedSlot(el.parentElement);
    return null;
};

export { findAssignedSlot };
